module.exports = __webpack_public_path__ + "static/media/picture.4e6179ab.svg";